import UrlHash from '../lib/urlHash';

export function showVote(timeout, callback) {
  const voteSelector = '.js-vote';
  const voteBodySelector = '.js-vote-body';
  const visibleClassName = 'is-visible';
  const $vote = document.querySelector(voteSelector);

  if ($vote) {
    let timeoutIndex;
    $vote.classList.add(visibleClassName);
    $vote.focus();

    function hide() {
      document.body.removeEventListener('click', listener);
      document.body.removeEventListener('keyup', listener);
      $vote.classList.remove(visibleClassName);

      if (timeoutIndex) {
        clearTimeout(timeoutIndex);
      }

      if (typeof callback === 'function') {
        callback.call();
      }
    }

    function listener(event) {
      if (event) {
        if (event.type === 'click' && !event.target.closest(voteBodySelector)) {
          event.preventDefault();
          hide();
        } else if (event.type === 'keyup' && event.keyCode === 27) {
          event.preventDefault();
          hide();
        }
      }
    }

    document.body.addEventListener('click', listener);
    document.body.addEventListener('keyup', listener);

    if (timeout) {
      timeoutIndex = setTimeout(() => {
        hide();
      }, timeout);
    }
  }
}

export default class Vote {
  constructor($container) {
    this.$container = $container;
    this.$button = this.$container.querySelector('.js-voting-button');

    this.$button.addEventListener('click', (event) => {
      event.preventDefault();

      this.save();
    });
  }

  save() {
    const buttonData = this.$button.dataset;

    return fetch(buttonData.url, {
      method: 'POST',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: UrlHash.fromObject({
        id: buttonData.id,
        csrfmiddlewaretoken: buttonData.csrf
      })
    })
      .then((rawResponse) => {
        if (rawResponse.ok) {
          return rawResponse.json();
        } else {
          throw new Error(rawResponse.statusText);
        }
      })
      .then((response) => {
        if (response && response.success) {
          showVote(3000, () => {
            UrlHash.clear();
            window.location.reload();
          });
        } else if (response && !response.success && response.message) {
          alert(response.message);
        } else {
          throw new Error('Неожиданный ответ сервера');
        }
      })
      .catch(({message}) => alert(message));
  }

  static initAll() {
    document.querySelectorAll('.js-voting').forEach(($container) => new Vote($container));
  }
}
